import { apiClient, getToken, getOrgId } from '@devd-client/api';

export const IgnorePrOrIssue = (params: any): Promise<any> =>
  apiClient(`/v1/${params.type}/org/${getOrgId()}?id=${params.id}`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify({}),
  });
